<template>
  <div class="higher-search-wrap higher-search-cus">
    <!--大的查询集合-->
    <div class="big-terms-content">
      <!--大的查询集合switch-->
      <div class="big-switch-line" v-if="termsGroup.length > 1"></div>
      <div class="big-switch-contents" v-if="termsGroup.length > 1">
        <el-switch
          style="display: block"
          v-model="outOperator"
          active-color="#13ce66"
          inactive-color="#ff4949"
          active-text="且"
          inactive-value="or"
          active-value="and"
          @change="update"
          class="big-switch"
          inactive-text="或">
        </el-switch>
      </div>
      <!--大的查询集合条件组-->
      <div class="big-term-content" v-for="(one, i) in termsGroup" :key="i">
        <!--小的查询集合-->
        <div class="search-wrap" style="overflow:hidden;">
          <div class="" :class="one | formatCusHigherSearchLine" v-if="one.terms.length > 1"></div>
          <div class="" :class="one | formatCusHigherSearchAndOr" v-if="one.terms.length > 1">
            <el-switch
              style="display: block"
              v-model="one.inOperator"
              active-color="#13ce66"
              inactive-color="#ff4949"
              @change="update"
              active-text="且"
              inactive-value="or"
              active-value="and"
              class="switch"
              inactive-text="或">
            </el-switch>
          </div>
          <div class="search-terms-content">
            <div v-for="(item, index) in one.terms" :key="index" class="term-item">
              <div class="block" style="text-align: left">
                <!--级联选择器-->
                <el-cascader
                  ref="select"
                  filterable
                  :options="options"
                  v-model="item.selectedOptions"
                  class="first-attr first-cascader special-high-search-fir"
                  @change="update(item)">
                </el-cascader>
                <!--相对关系-->
                <relationship @change="updates(item)" v-model="item.relationship" :relationOptions="item.relationOptions" class="relationSelect" v-if="item.selectedOptions[0] !== 'group' && item.selectedOptions[0] !== 'event' && item.selectedOptions[0] !== 'follow_public'"></relationship>
                <!--值-->
                <!--<values v-model="item.value" :realValue="item.value" @getQrcodes="getQrcodes" :item="item"></values>-->
                <!--判断是什么类型 input select等-->
                <!--select-->
                <!--属性select-->
                <el-select filterable @change="update" class="ifSelect" v-if="item.selectedOptions.length > 0 && item.selectedOptions[1].split('@')[1] === 'select' && item.relationship !== 'empty' && item.relationship !== 'not empty' && item.selectedOptions[0] === 'attr'" v-model="item.value" placeholder="请选择查询内容">
                  <el-option
                    v-for="i in item.option"
                    :key="i"
                    :label="i"
                    :value="i">
                  </el-option>
                </el-select>
                <!--属性radio-->
                <el-select filterable @change="update" class="ifSelect" v-if="item.selectedOptions.length > 0 && item.selectedOptions[1].split('@')[0] !== 'source_id' && item.selectedOptions[1].split('@')[0] !== 'stage_id' && item.selectedOptions[1].split('@')[1] === 'radio' && item.relationship !== 'empty' && item.relationship !== 'not empty' && item.selectedOptions[0] === 'attr'" v-model="item.value" placeholder="请选择查询内容">
                  <el-option
                    v-for="i in item.option"
                    :key="i"
                    :label="i"
                    :value="i">
                  </el-option>
                </el-select>
                <!--属性radio(初始来源)-->
                <el-select filterable @change="update" class="ifSelect" v-if="item.selectedOptions.length > 0 && item.selectedOptions[1].split('@')[0] === 'source_id' && item.selectedOptions[1].split('@')[1] === 'radio' && item.relationship !== 'empty' && item.relationship !== 'not empty' && item.selectedOptions[0] === 'attr'" v-model="item.value" placeholder="请选择查询内容">
                  <el-option
                    v-for="i in item.option"
                    :key="i.id"
                    :label="i.name"
                    :value="i.id">
                  </el-option>
                </el-select>
                <!--属性radio(客户等级)-->
                <el-select filterable @change="update" class="ifSelect" v-if="item.selectedOptions.length > 0 && item.selectedOptions[1].split('@')[0] === 'stage_id' && item.selectedOptions[1].split('@')[1] === 'radio' && item.relationship !== 'empty' && item.relationship !== 'not empty' && item.selectedOptions[0] === 'attr'" v-model="item.value" placeholder="请选择查询内容">
                  <el-option
                    v-for="i in item.option"
                    :key="i.id"
                    :label="i.name"
                    :value="i.id">
                  </el-option>
                </el-select>
                <!--群组-->
                <el-select @change="update" filterable class="ifSelect" v-if="item.selectedOptions.length > 0 && item.selectedOptions[1].split('@')[1] === 'select' && item.selectedOptions[0] === 'group'" v-model="item.value" placeholder="请选择查询内容">
                  <el-option
                    v-for="i in item.option"
                    :key="i.value"
                    :label="i.label"
                    :value="i.value">
                  </el-option>
                </el-select>
                <!--事件-->
                <el-select @blur="updateEvent(item)" filterable @change="eventChange(item)" class="ifSelect higher-search-event" v-if="item.selectedOptions.length > 0 && item.selectedOptions[0] === 'event' && item.selectedOptions[1] !== 'user_defined_event' && item.selectedOptions[1] !== 'order'" v-model="item.value" placeholder="请选择查询内容">
                  <el-option
                    v-for="i in item.option"
                    :key="i.value"
                    :label="i.label"
                    :value="i.value">
                  </el-option>
                </el-select>
                <!--关注公众号-->
                <el-select @blur="update(item)" @change="eventChange(item)" filterable class="ifSelect" v-if="item.selectedOptions.length > 0 && item.selectedOptions[1].split('@')[1] === 'select' && item.selectedOptions[0] === 'follow_public'" v-model="item.value" placeholder="请选择公众号">
                  <el-option
                    v-for="i in item.option"
                    :key="i.value"
                    :label="i.label"
                    :value="i.value">
                  </el-option>
                </el-select>
                <!--input-->
                <el-input maxlength="200" @input="update" v-if="item.selectedOptions[0] !== 'customer_kpi' && item.selectedOptions.length > 0 && item.selectedOptions[1].split('@')[1] === 'input' && item.relationship !== 'empty' && item.relationship !== 'not empty'" v-model="item.value" placeholder="请输入查询内容"></el-input>
                <!-- 数字 -->
                <el-input-number
                  v-if="
                    item.selectedOptions[0] === 'customer_kpi' &&
                    item.selectedOptions.length > 0 &&
                    item.selectedOptions[1].split('@')[1] === 'input' &&
                    item.relationship !== 'empty' &&
                    item.relationship !== 'not empty' &&
                    item.relationship !== 'gtele'"
                  controls-position="right"
                  class="input-number"
                  @input="update"
                  @blur="inputChange(item.value)"
                  type="number"
                  v-model="item.value"
                  placeholder="请输入数字">
                </el-input-number>
                <div v-if="
                        item.selectedOptions[0] === 'customer_kpi' &&
                        item.selectedOptions.length > 0 &&
                        item.selectedOptions[1].split('@')[1] === 'input' &&
                        item.relationship !== 'empty' &&
                        item.relationship !== 'not empty' &&
                        item.relationship === 'gtele'"
                  class="el-input-content">
                  <el-input-number
                    controls-position="right"
                    class="input-number-gtele-kpi"
                    @input="update"
                    maxlength="20"
                    type="number"
                    v-model="item.minKpiValue"
                    placeholder="请输入数字"
                    @blur="inputChange(item.minKpiValue)">
                  </el-input-number>
                  ~
                  <el-input-number
                    controls-position="right"
                    class="input-number-gtele-kpi"
                    @input="update"
                    maxlength="20"
                    type="number"
                    @blur="inputChange(item.maxKpiValue)"
                    v-model="item.maxKpiValue"
                    placeholder="请输入数字">
                  </el-input-number>
                </div>
                <!--datePicker-->
                <el-date-picker
                  v-if="item.selectedOptions.length > 0 && item.selectedOptions[1].split('@')[1] === 'datePicker' && item.relationship !== 'empty' && item.relationship !== 'not empty' && item.relationship !== 'gtele'"
                  v-model="item.value"
                  type="date"
                  class="dateTimePicker"
                  @change="update"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期">
                </el-date-picker>
                <!--dateTimePicker-->
                <el-date-picker
                  v-if="item.selectedOptions.length > 0 && item.selectedOptions[1].split('@')[1] === 'dateTimePicker' && item.relationship !== 'empty' && item.relationship !== 'not empty' && item.relationship !== 'gtele'"
                  v-model="item.value"
                  type="datetime"
                  class="dateTimePicker"
                  @change="update"
                  value-format="yyyy-MM-dd"
                  placeholder="选择时间和日期">
                </el-date-picker>
                <!--区间类日期选择-->
                <el-date-picker
                  v-if="item.selectedOptions.length > 0 && item.selectedOptions[1].split('@')[1] === 'datePicker' && item.relationship !== 'empty' && item.relationship !== 'not empty' && item.relationship === 'gtele'"
                  v-model="item.start_time"
                  type="date"
                  class="dateTimePicker"
                  @change="update"
                  @blur="chooseStartTime(item)"
                  value-format="yyyy-MM-dd"
                  placeholder="选择开始日期">
                </el-date-picker>
                <span style="padding: 0 6px" v-if="item.selectedOptions.length > 0 && item.selectedOptions[1].split('@')[1] === 'datePicker' && item.relationship !== 'empty' && item.relationship !== 'not empty' && item.relationship === 'gtele'">至</span>
                <el-date-picker
                  v-if="item.selectedOptions.length > 0 && item.selectedOptions[1].split('@')[1] === 'datePicker' && item.relationship !== 'empty' && item.relationship !== 'not empty' && item.relationship === 'gtele'"
                  v-model="item.end_time"
                  type="date"
                  class="dateTimePicker"
                  @blur="chooseEndTime(item)"
                  @change="update"
                  value-format="yyyy-MM-dd"
                  placeholder="选择结束日期">
                </el-date-picker>
                <!--区间类日期时间选择-->
                <el-date-picker
                  v-if="item.selectedOptions.length > 0 && item.selectedOptions[1].split('@')[1] === 'dateTimePicker' && item.relationship !== 'empty' && item.relationship !== 'not empty' && item.relationship === 'gtele'"
                  v-model="item.start_time"
                  type="datetime"
                  class="dateTimePicker"
                  @change="update"
                  value-format="yyyy-MM-dd"
                  placeholder="选择开始时间和日期">
                </el-date-picker>
                <span style="padding: 0 6px" v-if="item.selectedOptions.length > 0 && item.selectedOptions[1].split('@')[1] === 'dateTimePicker' && item.relationship !== 'empty' && item.relationship !== 'not empty' && item.relationship === 'gtele'">至</span>
                <el-date-picker
                  v-if="item.selectedOptions.length > 0 && item.selectedOptions[1].split('@')[1] === 'dateTimePicker' && item.relationship !== 'empty' && item.relationship !== 'not empty' && item.relationship === 'gtele'"
                  v-model="item.end_time"
                  type="datetime"
                  class="dateTimePicker"
                  @change="update"
                  value-format="yyyy-MM-dd"
                  placeholder="选择结束时间和日期">
                </el-date-picker>
                <!--addressPicker-->
                <el-cascader
                  v-if="item.selectedOptions.length > 0 && item.selectedOptions[1].split('@')[1] === 'addressPicker' && item.relationship !== 'empty' && item.relationship !== 'not empty'"
                  class="area"
                  size="large"
                  :options="addressOptions"
                  v-model="item.value"
                  @change="update">
                </el-cascader>
                <!--如果事件是扫描微信二维码-->
                <el-select filterable @change="updateQrcodes(item)" class="ifSelect"
                           v-if="item.selectedOptions.length > 0 && item.value !== '' && item.selectedOptions[0] === 'event' && item.selectedOptions[2].split('@')[0] === 'scan_qrcode'"
                           v-model="item.qrcode" placeholder="请选择查询内容">
                  <el-option
                    v-for="k in item.qrcodeOptions"
                    :key="k.id"
                    :label="k.title"
                    :value="k.id">
                  </el-option>
                </el-select>
                <!--如果事件是扫描线下活动二维码-->
                <el-select filterable @change="updateQrcode(item)" class="ifSelect"
                           v-if="item.selectedOptions.length > 0 && item.selectedOptions[0] === 'event' && item.selectedOptions[2].split('@')[0] === 'scan_offline_qrcode' && item.value !== ''"
                           v-model="item.offline_qrcode" placeholder="请选择查询内容">
                  <el-option
                    v-for="k in item.optionOther"
                    :key="k.id"
                    :label="k.qrcode_name"
                    :value="k.id">
                  </el-option>
                </el-select>
                <!--如果事件是发送微信模板消息-->
                <el-select filterable @change="updateTemplate(item)" class="ifSelect"
                           v-if="item.selectedOptions.length > 0 && item.value !== '' && item.selectedOptions[0] === 'event' && item.selectedOptions[2].split('@')[0] === 'send_tpl_message'"
                           v-model="item.template_id" placeholder="请选择查询内容">
                  <el-option
                    v-for="k in item.templateOption"
                    :key="k.id"
                    :label="k.title"
                    :value="k.id">
                  </el-option>
                </el-select>
                <!--向公众号留言input-->
                <el-input maxlength="50" @input="update" v-if="item.selectedOptions.length > 0 && item.selectedOptions[0] === 'event' && item.selectedOptions[2].split('@')[0] === 'leaving_message'" v-model="item.leave_word" placeholder="请输入留言内容"></el-input>
                <!------------------微信事件--微信客服回复部分--------------------->
                <!--如果事件是微信客服回复-->
                <el-select filterable @change="updateReplyTypes(item)" class="ifSelect wechat-reply"
                           v-if="item.selectedOptions.length > 0 && item.value !== '' && item.selectedOptions[0] === 'event' && item.selectedOptions[2].split('@')[0] === 'public_to_reply'"
                           v-model="item.public_reply_type_all.reply_type" placeholder="请选择查询内容">
                  <el-option
                    v-for="k in public_reply_types"
                    :key="k.id"
                    :label="k.title"
                    :value="k.id">
                  </el-option>
                </el-select>
                <!--微信客服回复--文字input-->
                <el-input maxlength="50" @input="update" v-if="item.selectedOptions.length > 0 && item.selectedOptions[0] === 'event' && item.selectedOptions[2].split('@')[0] === 'public_to_reply' && item.public_reply_type_all.reply_type === '文本'" v-model="item.public_reply_type_all.reply_content" placeholder="请输入查询内容（如不填即不限）"></el-input>
                <!--微信客服回复--微页面-->
                <el-select filterable @change="updateTemplate(item)" class="ifSelect"
                           v-if="item.selectedOptions.length > 0 && item.selectedOptions[0] === 'event' && item.selectedOptions[2].split('@')[0] === 'public_to_reply' && item.public_reply_type_all.reply_type === '微页面'"
                           v-model="item.public_reply_type_all.reply_content" placeholder="请选择查询内容">
                  <el-option
                    v-for="k in item.wepageTwo"
                    :key="k.name"
                    :label="k.label"
                    :value="k.name">
                  </el-option>
                </el-select>
                <!--微信客服回复--文字input-->
                <el-input maxlength="200" @input="update" v-if="item.selectedOptions.length > 0 && item.selectedOptions[0] === 'event' && item.selectedOptions[2].split('@')[0] === 'public_to_reply' && item.public_reply_type_all.reply_type === '外部页面'" v-model="item.public_reply_type_all.reply_content" placeholder="请输入标题或链接（如不填即不限）"></el-input>
                <!--微信客服回复--大转盘-->
                <el-select filterable @change="updateTemplate(item)" class="ifSelect"
                           v-if="item.selectedOptions.length > 0 && item.selectedOptions[0] === 'event' && item.selectedOptions[2].split('@')[0] === 'public_to_reply' && item.public_reply_type_all.reply_type === '大转盘'"
                           v-model="item.public_reply_type_all.reply_content" placeholder="请选择查询内容">
                  <el-option
                    v-for="k in item.activitiesTwo"
                    :key="k.name"
                    :label="k.label"
                    :value="k.name">
                  </el-option>
                </el-select>
                <!--微信客服回复--关联模块-->
                <el-select filterable @change="updateTemplate(item)" class="ifSelect"
                           v-if="item.selectedOptions.length > 0 && item.selectedOptions[0] === 'event' && item.selectedOptions[2].split('@')[0] === 'public_to_reply' && item.public_reply_type_all.reply_type === '关联模块'"
                           v-model="item.public_reply_type_all.reply_content" placeholder="请选择查询内容">
                  <el-option
                    v-for="k in aboutModels"
                    :key="k.name"
                    :label="k.label"
                    :value="k.name">
                  </el-option>
                </el-select>
                <!--微信客服回复--模板消息-->
                <el-select filterable @change="updateTemplate(item)" class="ifSelect"
                           v-if="item.selectedOptions.length > 0 && item.selectedOptions[0] === 'event' && item.selectedOptions[2].split('@')[0] === 'public_to_reply' && item.public_reply_type_all.reply_type === '模板消息'"
                           v-model="item.public_reply_type_all.reply_content" placeholder="请选择查询内容">
                  <el-option
                    v-for="k in item.templatesTwo"
                    :key="k.name"
                    :label="k.label"
                    :value="k.name">
                  </el-option>
                </el-select>
                <div class="remove-btn" @click="removeTermItem(index, i)" v-if="num > 1">
                  <i class="el-icon-close" title="删除当前条件"></i>
                </div>
                <!--如果是客户事件-->
                <div class="action-select" v-if="item.selectedOptions[0] == 'event'">
                  <el-row class="action-select-row" style="height: 32px;line-height: 32px">
                    <el-checkbox @change="sendValues" v-model="item.eventLimitTime">限制起止时间</el-checkbox>
                    <!--<el-checkbox @change="sendValues" v-model="item.eventLimitTimes">限制次数</el-checkbox>-->
                    <el-checkbox @change="changeLimitEventAttr(item)" v-if="item.selectedOptions[1] !== 'order'" v-model="item.eventLimitAttr">限制事件属性</el-checkbox>
                  </el-row>
                  <!--限制时间-->
                  <el-row class="action-select-row" style="line-height: 40px" v-if="item.eventLimitTime">
                    <el-col :span="2" class="action-select-row-title">起止时间:</el-col>
                    <el-col :span="22" v-if="item.eventLimitTime">
                      <el-date-picker
                        v-model="item.eventDateStart"
                        type="datetime"
                        time-arrow-control
                        @change="judgeDateStart(item)"
                        class="event-son-input arrowPositionSelect date-time-search font-size-14"
                        placeholder="选择时间和日期">
                      </el-date-picker>
                      -
                      <el-date-picker
                        v-model="item.eventDateEnd"
                        type="datetime"
                        time-arrow-control
                        @change="judgeDate(item)"
                        class="event-son-input arrowPositionSelect date-time-search font-size-14"
                        placeholder="选择时间和日期">
                      </el-date-picker>
                    </el-col>
                  </el-row>
                  <!--限制次数-->
                  <el-row class="action-select-row" style="line-height: 40px" v-if="item.eventLimitTimes">
                    <el-col :span="2" class="action-select-row-title">发生次数:</el-col>
                    <el-col :span="15" style="">
                      <el-select @change="sendValues" style="width: auto;margin-right: 7px" class="event-son-input arrowPositionSelect happend-times font-size-14" v-model="item.eventTimeRelation" placeholder="请选择">
                        <el-option
                          v-for="k in eventTimesList"
                          :key="k.value"
                          :label="k.label"
                          :value="k.value">
                        </el-option>
                      </el-select>
                      <el-input-number @input="sendValues" :min="1" :max="100000000" controls-position="right" placeholder="请输入次数" v-if="item.eventTimeRelation === 'gtele'" class="event-son-input font-size-14" v-model="item.happenedTimes"></el-input-number>
                      <span v-if="item.eventTimeRelation=='gtele'" style="padding-left: 0"> — </span>
                      <el-input-number @input="sendValues" :min="1" :max="100000000" controls-position="right" placeholder="请输入次数" class="event-son-input font-size-14"  v-if="item.eventTimeRelation === 'gtele'" v-model="item.happenedTimes"></el-input-number>
                      <el-input-number @input="sendValues" :min="1" :max="100000000" controls-position="right" placeholder="请输入次数" class="event-son-input font-size-14" v-if="item.eventTimeRelation !== 'gtele' && item.eventTimeRelation !== 'at_least_once' && item.eventTimeRelation !== 'no_once'" v-model="item.happenedTimes"></el-input-number>
                    </el-col>
                  </el-row>
                  <!--限制属性-->
                  <div v-if="item.eventLimitAttr">
                    <el-row class="action-select-row limit-attr" style="line-height: 40px">
                      <el-col :span="24" v-for="(itemAttr, ai) in item.eventAttrOptions" :key="ai">
                        <el-col :span="2" class="action-select-row-title">
                          <span style="padding-left: 0">
                            <span style="padding-left: 0" v-if="ai === 0">事件属性:</span>
                            <span style="padding-left: 0" v-if="ai !== 0">&nbsp;&nbsp;&nbsp;&nbsp;</span>
                          </span>
                        </el-col>
                        <!--事件属性名字-->
                        <el-select filterable @change="changeLimitRelation(item, itemAttr)" v-if="item.selectedOptions.length > 0 && item.selectedOptions[0] === 'event' && item.selectedOptions[1] !== 'order'" class="event-son-input arrowPositionSelect" v-model="itemAttr.attributeContent" placeholder="请选择事件属性">
                          <el-option
                            v-for="k in item.eventAttributeList"
                            :key="k.value"
                            :label="k.label"
                            :value="k.value">
                          </el-option>
                        </el-select>
                        <el-cascader
                          v-if="item.selectedOptions.length > 0 && item.selectedOptions[0] === 'event' && item.selectedOptions[1] === 'order'"
                          filterable
                          :options="item.eventAttributeList"
                          v-model="itemAttr.attributeContent"
                          @change="changeLimitRelations(itemAttr)"
                          class="first-attr first-cascader">
                        </el-cascader>
                        <!--相对关系-->
                        <el-select @change="sendValues" class="event-son-input arrowPositionSelect limit-relation" v-model="itemAttr.attributeRelation" placeholder="相对关系">
                          <el-option
                            v-for="k in itemAttr.relationOptions"
                            :key="k.value"
                            :label="k.label"
                            :value="k.value">
                          </el-option>
                        </el-select>
                        <!--值-->
                        <el-select filterable @change="sendValues" v-if="itemAttr.attributeRelation !== 'empty' && itemAttr.attributeRelation !== 'not_empty' && itemAttr.attributeContent === 'source'" class="event-son-input arrowPositionSelect limit-relation" v-model="itemAttr.attributeValue" placeholder="选择来源">
                          <el-option
                            v-for="k in itemAttr.sources"
                            :key="k.value"
                            :label="k.label"
                            :value="k.value">
                          </el-option>
                        </el-select>
                        <el-input maxlength="200" @input="update" v-if="itemAttr.attributeRelation !== 'empty' && itemAttr.attributeRelation !== 'not_empty' && itemAttr.attributeContent[1] !== 'order_time' && itemAttr.attributeContent !== 'source' && item.selectedOptions[1] !== 'user_defined_event'" v-model="itemAttr.attributeValue" placeholder="请输入限制内容"></el-input>
                        <el-input maxlength="200" @input="update" v-if="itemAttr.attributeRelation !== 'empty' && itemAttr.attributeRelation !== 'not_empty' && item.selectedOptions[1] === 'user_defined_event' && itemAttr.attributeContent !== 'source' && itemAttr.attr_type === 'txt'" v-model="itemAttr.attributeValue" placeholder="请输入限制内容"></el-input>
                        <el-input-number @input="update" :min="1" :max="100000000" controls-position="right" placeholder="请输入次数" class="event-son-input font-size-14"  v-if="itemAttr.attributeRelation !== 'empty' && itemAttr.attributeRelation !== 'gtele' && itemAttr.attributeRelation !== 'not_empty' && item.selectedOptions[1] === 'user_defined_event' && itemAttr.attr_type === 'money'" v-model="itemAttr.attributeValue"></el-input-number>
                        <el-input-number @input="update" :min="1" :max="100000000" controls-position="right" placeholder="请输入次数" class="event-son-input font-size-14"  v-if="itemAttr.attributeRelation !== 'empty' && itemAttr.attributeRelation !== 'gtele' && itemAttr.attributeRelation !== 'not_empty' && item.selectedOptions[1] === 'user_defined_event' && itemAttr.attr_type === 'number'" v-model="itemAttr.attributeValue"></el-input-number>
                        <el-input-number @input="update" :min="1" :max="100000000" controls-position="right" placeholder="请输入次数" class="event-son-input font-size-14"  v-if="itemAttr.attributeRelation !== 'empty' && itemAttr.attributeRelation === 'gtele' && itemAttr.attributeRelation !== 'not_empty' && item.selectedOptions[1] === 'user_defined_event' && itemAttr.attr_type === 'money'" v-model="itemAttr.attributeValueStart"></el-input-number>
                        <span v-if="itemAttr.attributeRelation !== 'empty' && itemAttr.attributeRelation === 'gtele' && itemAttr.attributeRelation !== 'not_empty' && item.selectedOptions[1] === 'user_defined_event' && itemAttr.attr_type === 'money'">-</span>
                        <el-input-number @input="update" :min="1" :max="100000000" controls-position="right" placeholder="请输入次数" class="event-son-input font-size-14"  v-if="itemAttr.attributeRelation !== 'empty' && itemAttr.attributeRelation === 'gtele' && itemAttr.attributeRelation !== 'not_empty' && item.selectedOptions[1] === 'user_defined_event' && itemAttr.attr_type === 'money'" v-model="itemAttr.attributeValueEnd"></el-input-number>
                        <el-date-picker
                          v-if="itemAttr.attributeRelation !== 'gtele' && itemAttr.attributeContent[1] === 'order_time' && item.selectedOptions[1] !== 'user_defined_event'"
                          v-model="itemAttr.attributeValue"
                          type="datetime"
                          @change="sendValues"
                          class="event-son-input arrowPositionSelect date-time-search font-size-14"
                          placeholder="选择时间和日期">
                        </el-date-picker>
                        <!--区间-->
                        <el-date-picker
                          v-if="itemAttr.attributeRelation === 'gtele' && itemAttr.attributeContent[1] === 'order_time' && item.selectedOptions[1] !== 'user_defined_event'"
                          v-model="itemAttr.attrValTimeStart"
                          type="datetime"
                          @change="judgeDatesStart(itemAttr)"
                          class="event-son-input arrowPositionSelect date-time-search font-size-14"
                          placeholder="选择时间和日期">
                        </el-date-picker>
                        <span v-if="itemAttr.attributeRelation === 'gtele' && itemAttr.attributeContent[1] === 'order_time' && item.selectedOptions[1] !== 'user_defined_event'">-</span>
                        <el-date-picker
                          v-if="itemAttr.attributeRelation === 'gtele' && itemAttr.attributeContent[1] === 'order_time' && item.selectedOptions[1] !== 'user_defined_event'"
                          v-model="itemAttr.attrValTimeEnd"
                          type="datetime"
                          @change="judgeDates(itemAttr)"
                          class="event-son-input arrowPositionSelect date-time-search font-size-14"
                          placeholder="选择时间和日期">
                        </el-date-picker>
                        <div class="remove-btn remove-btn-attribute" @click="removeAttributeItem(item, ai)" v-if="item.eventAttrOptions.length>1">
                          <i class="el-icon-error" title="删除当前条件"></i>
                        </div>
                      </el-col>
                    </el-row>
                    <el-row v-if="item.eventAttrOptions.length < 8 && item.eventAttrOptions.length > 0" class="add-new-terms">
                      <div class="add-new-term-btn add-new-term-btn-attribute" @click="addNewEventAttribute(item)">
                        <i class="el-icon-plus"></i>
                        添加事件属性限制
                      </div>
                    </el-row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="add-new-terms" v-if="one.terms.length > 0">
          <div class="add-new-term-btn" @click="addNewTerm(i)">
            <i class="el-icon-circle-plus-outline"></i>
            增加一个条件
          </div>
        </div>
      </div>
    </div>
    <!--增加一组条件按钮-->
    <div class="add-one-group-terms">
      <div class="add-one-group-terms-btn" @click="addNewTermGroup">
        <i class="el-icon-circle-plus-outline"></i>
        增加一组条件
      </div>
    </div>
  </div>
</template>

<script>
import { regionDataPlus, CodeToText, TextToCode } from 'element-china-area-data'
import { getCustomerAttributeList, getCustomerStage, getSourceData, getBigWheelList, getMessageListForNode, getGroupList, getCustomerEventList, getWechatPublicListForNode, WePagesList } from '@/api/customer.js'
import { mapGetters } from 'vuex'
import relationship from './../common/higher-search-relationship.vue'
import values from './../common/higher-search-values.vue'
export default {
  name: '',
  props: ['forSonTerms', 'allRelationship', 'allRelationshipSearch'],
  data () {
    return {
      eventTimesList: [ // 客户事件--发生次数下拉
        {
          value: 'at_least_once',
          label: '至少一次'
        },
        {
          value: 'no_once',
          label: '一次没有'
        },
        {
          value: 'equal',
          label: '等于'
        },
        {
          value: 'lt',
          label: '小于'
        },
        {
          value: 'lte',
          label: '小于等于'
        },
        {
          value: 'gt',
          label: '大于'
        },
        {
          value: 'gte',
          label: '大于等于'
        },
        {
          value: 'gtele',
          label: '区间'
        }
      ],
      tmp_qrcode: null,
      changed: false,
      qrcodePval: '',
      wechatPublic: [],
      wepage: [],
      qrcodes: [],
      offlineQrcodes: [],
      templates: [],
      activities: [],
      aboutModels: [
        {
          label: '不限',
          name: '不限'
        },
        {
          label: '会员中心',
          name: '会员中心'
        },
        {
          label: '线下活动',
          name: '线下活动'
        }
      ],
      public_reply_types: [
        {
          title: '不限',
          id: '不限'
        },
        {
          title: '文本',
          id: '文本'
        },
        {
          title: '图片',
          id: '图片'
        },
        {
          title: '微页面',
          id: '微页面'
        },
        {
          title: '外部页面',
          id: '外部页面'
        },
        {
          title: '大转盘',
          id: '大转盘'
        },
        {
          title: '关联模块',
          id: '关联模块'
        },
        {
          title: '模板消息',
          id: '模板消息'
        }
      ],
      sms: [],
      outOperator: 'and',
      relationshipUse: '',
      addressOptions: regionDataPlus,
      options: [
        {
          value: 'attr',
          label: '客户属性',
          children: []
        },
        {
          value: 'group',
          label: '群组',
          children: []
        },
        {
          value: 'event',
          label: '客户事件',
          children: []
        },
        {
          value: 'follow_public',
          label: '关注公众号',
          children: []
        },
        {
          value: 'customer_kpi',
          label: '客户关键指标',
          children: [
            {
              label: '客户活跃度',
              value: 'integrate@input',
              option: [],
              identity: 'integrate'
            },
            {
              label: '客户7天活跃度',
              value: 'integrate_seven_days@input',
              option: [],
              identity: 'integrate_seven_days'
            },
            {
              label: '客户30天活跃度',
              value: 'integrate_thirty_days@input',
              option: [],
              identity: 'integrate_thirty_days'
            },
            {
              label: '客户价值评分',
              value: 'worth_integrate@input',
              option: [],
              identity: 'worth_integrate'
            },
            {
              label: '客户资料分',
              value: 'means_integrate@input',
              option: [],
              identity: 'means_integrate'
            }
          ]
        },
        {
          value: 'customer_identity',
          label: '客户身份',
          children: [
            {
              label: '微信openid',
              value: 'wechat_openid@input',
              option: [],
              identity: 'wechat_openid'
            }
          ]
        }
      ],
      relationOptions: [
        {
          value: '=',
          label: '等于'
        }, {
          value: '!=',
          label: '不等于'
        }, {
          value: 'contain',
          label: '包含'
        }, {
          value: 'not contain',
          label: '不包含'
        }, {
          value: 'empty',
          label: '为空'
        },
        {
          value: 'not empty',
          label: '不为空'
        }
      ],
      relation: '',
      ifSelect: '',
      ifSelectOptions: [],
      ifInput: '',
      ifRadio: '',
      termsGroup: JSON.parse(JSON.stringify(this.forSonTerms)),
      search: {}
    }
  },
  components: {
    'relationship': relationship,
    'values': values
  },
  watch: {
    forSonTerms: function (val) {
      this.termsGroup = val
    }
  },
  computed: {
    ...mapGetters([
      'getQuery'
    ]),
    num() {
      let num = 0
      for (let item of this.termsGroup) {
        num = num + item.terms.length
      }
      return num
    },
    nums() {
      let nums = 0
      for (let item of this.termsGroup) {
        for (let one of item.terms) {
          nums = nums + one.eventAttrOptions.length
        }
      }
      return nums
    },
    allTerms() {
      let allTerms = {}
      allTerms.allRelationship = this.outOperator
      allTerms.termsGroup = this.termsGroup
      return allTerms
    }
  },
  methods: {
    inputChange(value) {
      if (value.length > 20) {
        value.substr(0, 20)
        _g.toastMsg('error', '输入数字位数不能大于20')
      }
    },
    // 处理限制事件属性
    changeLimitEventAttr(item) {
      if (item.eventLimitAttr === false) {
        item.eventAttrOptions = [
          {
            attributeContent: '',
            relationOptions: [],
            eventAttrValueOptions: [],
            attributeRelation: '',
            attrValTimeStart: '',
            attrValTimeEnd: '',
            attributeValue: ''
          }
        ]
        // 判断事件类型展示限制属性
        if (item.selectedOptions[1] === 'wechat' || item.selectedOptions[1] === 'wepage' || item.selectedOptions[1] === 'sms' || item.selectedOptions[1] === 'interactive_activities') {
          for (let ling of item.eventAttrOptions) {
            ling.attributeContent = ''
            ling.attributeRelation = ''
            ling.attributeValue = ''
            ling.attrValTimeStart = ''
            ling.attrValTimeEnd = ''
          }
          item.eventAttributeList = [
            {
              value: 'source',
              label: '来源'
            },
            {
              value: 'source_content',
              label: '来源内容'
            },
            {
              value: 'serial_number',
              label: '活动营销编码'
            }
          ]
        }
        if (item.selectedOptions[1] === 'user_defined_event') {
          for (let ling of item.eventAttrOptions) {
            ling.attributeContent = ''
            ling.attributeRelation = ''
            ling.attributeValue = ''
            ling.attrValTimeStart = ''
            ling.attrValTimeEnd = ''
            for (let er of item.limit_attr) {
              er.label = er.attr_name
              er.value = er.attr_identity
            }
            item.eventAttributeList = item.limit_attr
          }
        }
        if (item.selectedOptions[1] === 'order') {
          for (let yi of item.eventAttrOptions) {
            yi.attributeContent = []
            yi.attributeRelation = ''
            yi.attributeValue = ''
            yi.attrValTimeStart = ''
            yi.attrValTimeEnd = ''
            item.eventAttributeList = [
              {
                value: 'goods_info',
                label: '商品信息',
                children: [
                  {
                    value: 'preferential_type',
                    label: '优惠类型'
                  },
                  {
                    value: 'coupon',
                    label: '优惠券'
                  },
                  {
                    value: 'goods_name',
                    label: '商品名称'
                  },
                  {
                    value: 'skuid',
                    label: 'skuid'
                  },
                  {
                    value: 'brand',
                    label: '品牌名称'
                  },
                  {
                    value: 'category',
                    label: '品类'
                  }
                ]
              },
              {
                value: 'order_info',
                label: '订单信息',
                children: [
                  {
                    value: 'distribution_channel',
                    label: '销售渠道'
                  },
                  {
                    value: 'shop_name',
                    label: '店铺名称'
                  },
                  {
                    value: 'order_no',
                    label: '订单号'
                  },
                  {
                    value: 'order_type',
                    label: '订单类型'
                  },
                  {
                    value: 'order_time',
                    label: '下单时间'
                  },
                  {
                    value: 'order_discount',
                    label: '订单折扣'
                  },
                  {
                    value: 'preferential_type',
                    label: '优惠类型'
                  },
                  {
                    value: 'coupon',
                    label: '优惠券'
                  },
                  {
                    value: 'pay_way',
                    label: '支付方式'
                  },
                  {
                    value: 'send_way',
                    label: '运送方式'
                  },
                  {
                    value: 'serial_number',
                    label: '营销活动编码'
                  }
                ]
              },
              {
                value: 'receive_goods_info',
                label: '收货信息',
                children: [
                  {
                    value: 'receiver_name',
                    label: '收货人姓名'
                  },
                  {
                    value: 'receiver_province',
                    label: '收货人省份'
                  },
                  {
                    value: 'receiver_city',
                    label: '收货人城市'
                  },
                  {
                    value: 'receiver_district',
                    label: '收货人区县'
                  },
                  {
                    value: 'receiver_street',
                    label: '收货人街道'
                  },
                  {
                    value: 'receiver_address',
                    label: '收货人详细地址'
                  }
                ]
              },
              {
                value: 'statistics_info',
                label: '统计信息',
                children: [
                  {
                    value: 'goods_types',
                    label: '商品种类数'
                  },
                  {
                    value: 'goods_num',
                    label: '商品件数'
                  },
                  {
                    value: 'unit_price',
                    label: '件单价'
                  }
                ]
              }
            ]
          }
        }
      }
      this.sendValues()
    },
    // 判断限制时间开始时间不能大于结束时间
    judgeDate(item) {
      if (Date.parse(new Date(item.eventDateStart)) > Date.parse(new Date(item.eventDateEnd))) {
        item.eventDateEnd = ''
        _g.toastMsg('error', '开始时间不能大于结束时间')
      }
      this.sendValues()
    },
    // 判断限制时间开始时间不能大于结束时间
    judgeDateStart(item) {
      if (Date.parse(new Date(item.eventDateStart)) > Date.parse(new Date(item.eventDateEnd))) {
        item.eventDateEnd = ''
        _g.toastMsg('error', '开始时间不能大于结束时间')
      }
      this.sendValues()
    },
    // 判断下单时间开始时间不能大于结束时间
    judgeDatesStart(item) {
      if (Date.parse(new Date(item.attrValTimeStart)) > Date.parse(new Date(item.attrValTimeEnd))) {
        item.attrValTimeEnd = ''
        _g.toastMsg('error', '开始时间不能大于结束时间')
      }
      this.sendValues()
    },
    // 判断下单时间开始时间不能大于结束时间
    judgeDates(item) {
      if (Date.parse(new Date(item.attrValTimeStart)) > Date.parse(new Date(item.attrValTimeEnd))) {
        item.attrValTimeEnd = ''
        _g.toastMsg('error', '开始时间不能大于结束时间')
      }
      this.sendValues()
    },
    // 删除属性限制
    removeAttributeItem(item, ai) {
      item.eventAttrOptions.splice(ai, 1)
    },
    // 添加属性限制
    addNewEventAttribute(item) {
      item.eventAttrOptions.push({
        attributeContent: '',
        relationOptions: [],
        eventAttrValueOptions: [],
        attributeRelation: '',
        attr_type: '',
        attrValTimeStart: '',
        attrValTimeEnd: '',
        attributeValue: ''
      })
      // 判断事件类型展示限制属性
      if (item.selectedOptions[1] === 'wechat' || item.selectedOptions[1] === 'wepage' || item.selectedOptions[1] === 'sms' || item.selectedOptions[1] === 'interactive_activities') {
        item.eventAttributeList = [
          {
            value: 'source',
            label: '来源'
          },
          {
            value: 'source_content',
            label: '来源内容'
          },
          {
            value: 'serial_number',
            label: '活动营销编码'
          }
        ]
      }
      if (item.selectedOptions[1] === 'user_defined_event') {
        for (let er of item.limit_attr) {
          er.label = er.attr_name
          er.value = er.attr_identity
        }
        item.eventAttributeList = item.limit_attr
      }
      if (item.selectedOptions[1] === 'order') {
        item.eventAttributeList = [
          {
            value: 'goods_info',
            label: '商品信息',
            children: [
              {
                value: 'preferential_type',
                label: '优惠类型'
              },
              {
                value: 'coupon',
                label: '优惠券'
              },
              {
                value: 'goods_name',
                label: '商品名称'
              },
              {
                value: 'skuid',
                label: 'skuid'
              },
              {
                value: 'brand',
                label: '品牌名称'
              },
              {
                value: 'category',
                label: '品类'
              }
            ]
          },
          {
            value: 'order_info',
            label: '订单信息',
            children: [
              {
                value: 'distribution_channel',
                label: '销售渠道'
              },
              {
                value: 'shop_name',
                label: '店铺名称'
              },
              {
                value: 'order_no',
                label: '订单号'
              },
              {
                value: 'order_type',
                label: '订单类型'
              },
              {
                value: 'order_time',
                label: '下单时间'
              },
              {
                value: 'order_discount',
                label: '订单折扣'
              },
              {
                value: 'preferential_type',
                label: '优惠类型'
              },
              {
                value: 'coupon',
                label: '优惠券'
              },
              {
                value: 'pay_way',
                label: '支付方式'
              },
              {
                value: 'send_way',
                label: '运送方式'
              },
              {
                value: 'serial_number',
                label: '营销活动编码'
              }
            ]
          },
          {
            value: 'receive_goods_info',
            label: '收货信息',
            children: [
              {
                value: 'receiver_name',
                label: '收货人姓名'
              },
              {
                value: 'receiver_province',
                label: '收货人省份'
              },
              {
                value: 'receiver_city',
                label: '收货人城市'
              },
              {
                value: 'receiver_district',
                label: '收货人区县'
              },
              {
                value: 'receiver_street',
                label: '收货人街道'
              },
              {
                value: 'receiver_address',
                label: '收货人详细地址'
              }
            ]
          },
          {
            value: 'statistics_info',
            label: '统计信息',
            children: [
              {
                value: 'goods_types',
                label: '商品种类数'
              },
              {
                value: 'goods_num',
                label: '商品件数'
              },
              {
                value: 'unit_price',
                label: '件单价'
              }
            ]
          }
        ]
      }
    },
    // 级联选择之后加载限制属性相对关系
    changeLimitRelations(item) {
      item.attributeValue = ''
      item.attrValTimeStart = ''
      item.attrValTimeEnd = ''
      item.attributeRelation = ''
      item.attributeValueStart = ''
      item.attributeValueEnd = ''
      if (item.attributeContent[0] === 'goods_info' || item.attributeContent[0] === 'order_info' || item.attributeContent[0] === 'receive_goods_info') {
        item.relationOptions = [
          {
            value: 'equal',
            label: '等于'
          },
          {
            value: 'not_equal',
            label: '不等于'
          },
          {
            value: 'empty',
            label: '为空'
          },
          {
            value: 'not_empty',
            label: '不为空'
          },
          {
            value: 'contain',
            label: '包含'
          },
          {
            value: 'not_contain',
            label: '不包含'
          }
        ]
      }
      if (item.attributeContent[1] === 'order_time') {
        item.relationOptions = [
          {
            value: 'equal',
            label: '等于'
          },
          {
            value: 'not_equal',
            label: '不等于'
          },
          {
            value: 'before',
            label: '早于'
          },
          {
            value: 'past',
            label: '晚于'
          },
          {
            value: 'gtele',
            label: '区间'
          }
        ]
      }
      if (item.attributeContent[0] === 'statistics_info') {
        if (item.attributeContent[1] === 'goods_types' || item.attributeContent[1] === 'goods_num') {
          item.relationOptions = [
            {
              value: 'equal',
              label: '等于'
            },
            {
              value: 'not_equal',
              label: '不等于'
            },
            {
              value: 'empty',
              label: '为空'
            },
            {
              value: 'not_empty',
              label: '不为空'
            },
            {
              value: 'contain',
              label: '包含'
            }
          ]
        }
        if (item.attributeContent[1] === 'unit_price') {
          item.relationOptions = [
            {
              value: 'equal',
              label: '等于'
            },
            {
              value: 'not_equal',
              label: '不等于'
            },
            {
              value: 'gt',
              label: '大于'
            },
            {
              value: 'gte',
              label: '大于等于'
            },
            {
              value: 'lt',
              label: '小于'
            },
            {
              value: 'lte',
              label: '小于等于'
            },
            {
              value: 'gtele',
              label: '区间'
            }
          ]
        }
      }
      this.sendValues()
    },
    // 选择之后加载限制属性相对关系
    changeLimitRelation(item, itemAttr) {
      itemAttr.attributeRelation = ''
      itemAttr.attributeValue = ''
      itemAttr.attrValTimeStart = ''
      itemAttr.attrValTimeEnd = ''
      itemAttr.attributeValueStart = ''
      itemAttr.attributeValueEnd = ''
      if (itemAttr.attributeContent === 'source') {
        getSourceData().then((res) => {
          for (let items of res.data.data.list) {
            items.label = items.name
            items.value = items.name
          }
          itemAttr.sources = res.data.data.list
          console.log('itemAttr.sources', itemAttr.sources)
        })
      }
      if (item.selectedOptions[1] !== 'user_defined_event' && item.selectedOptions[1] !== 'order') {
        if (itemAttr.attributeContent === 'source') {
          itemAttr.relationOptions = [
            {
              value: 'equal',
              label: '等于'
            },
            {
              value: 'not_equal',
              label: '不等于'
            },
            {
              value: 'empty',
              label: '为空'
            },
            {
              value: 'not_empty',
              label: '不为空'
            }
          ]
        }
        if (itemAttr.attributeContent === 'source_content' || itemAttr.attributeContent === 'serial_number') {
          itemAttr.relationOptions = [
            {
              value: 'equal',
              label: '等于'
            },
            {
              value: 'not_equal',
              label: '不等于'
            },
            {
              value: 'empty',
              label: '为空'
            },
            {
              value: 'not_empty',
              label: '不为空'
            },
            {
              value: 'contain',
              label: '包含'
            },
            {
              value: 'not_contain',
              label: '不包含'
            }
          ]
        }
      }
      if (item.selectedOptions[1] === 'user_defined_event') {
        for (let yi of item.eventAttributeList) {
          if (itemAttr.attributeContent === yi.attr_identity) {
            itemAttr.attr_type = yi.attr_type
          }
        }
        if (itemAttr.attr_type === 'txt') {
          itemAttr.relationOptions = [
            {
              value: 'equal',
              label: '等于'
            },
            {
              value: 'not_equal',
              label: '不等于'
            },
            {
              value: 'contain',
              label: '包含'
            },
            {
              value: 'not_contain',
              label: '不包含'
            },
            {
              value: 'empty',
              label: '为空'
            },
            {
              value: 'not_empty',
              label: '不为空'
            }
          ]
        }
        if (itemAttr.attr_type === 'money') {
          itemAttr.relationOptions = [
            {
              value: 'equal',
              label: '等于'
            },
            {
              value: 'not_equal',
              label: '不等于'
            },
            {
              value: 'gt',
              label: '大于'
            },
            {
              value: 'gte',
              label: '大于等于'
            },
            {
              value: 'lt',
              label: '小于'
            },
            {
              value: 'lte',
              label: '小于等于'
            },
            {
              value: 'gtele',
              label: '区间'
            }
          ]
        }
        if (itemAttr.attr_type === 'number') {
          itemAttr.relationOptions = [
            {
              value: 'equal',
              label: '等于'
            },
            {
              value: 'not_equal',
              label: '不等于'
            },
            {
              value: 'empty',
              label: '为空'
            },
            {
              value: 'not_empty',
              label: '不为空'
            }
          ]
        }
      }
      this.sendValues()
    },
    updates(item) {
      // 传值到父组件
      let allTerms = {}
      allTerms.allRelationship = this.outOperator
      for (let item of this.termsGroup) {
        for (let one of item.terms) {
          let firAttr = one.selectedOptions[0]
          one.attr = firAttr
        }
      }
      allTerms.termsGroup = this.termsGroup
      this.$emit('change', allTerms)
    },
    getQrcodes(value) {
      this.qrcodes = value
    },
    chooseStartTime(item) {
      // 判断属性的时间类区间开始不能大于结束
      if (Date.parse(new Date(item.start_time)) > Date.parse(new Date(item.end_time))) {
        item.end_time = ''
        _g.toastMsg('error', '开始时间不能大于结束时间')
      }
    },
    chooseEndTime(item) {
      // 判断属性的时间类区间开始不能大于结束
      if (Date.parse(new Date(item.start_time)) > Date.parse(new Date(item.end_time))) {
        item.end_time = ''
        _g.toastMsg('error', '开始时间不能大于结束时间')
      }
    },
    // 专门传值到父组件
    sendValues() {
      let allTerms = {}
      allTerms.allRelationship = this.outOperator
      for (let item of this.termsGroup) {
        for (let one of item.terms) {
          let firAttr = one.selectedOptions[0]
          one.attr = firAttr
        }
      }
      allTerms.termsGroup = this.termsGroup
      this.$emit('change', allTerms)
    },
    // 事件选择发送微信模板
    updateTemplate(item) {
      this.sendValues()
    },
    // 切换微信回复类型
    updateReplyTypes(item) {
      item.public_reply_type_all.reply_content = null
      this.sendValues()
    },
    // 事件选完传值
    updateEvent(item) {
      this.sendValues()
    },
    // 事件选择公众号离开的时候
    eventChange(item) {
      // 如果是关注公众号  将公众号的原始id也放进去
      if (item.selectedOptions[0] === 'follow_public') {
        for (let yi of item.option) {
          if (parseInt(yi.id) === parseInt(item.value)) {
            item.original_id = yi.original_id
          }
        }
      }
      // 如果是微信  将公众号的原始id也放进去
      if (item.selectedOptions[1] === 'wechat') {
        for (let yi of item.option) {
          if (yi.id === item.value) {
            item.original_id = yi.original_id
          }
        }
      }
      // 处理公众号二维码选择问题
      if (item.selectedOptions[0] === 'event' && item.selectedOptions[2].split('@')[0] === 'scan_qrcode') {
        for (let j in item.option) {
          if (item.value === item.option[j].id) {
            if (item.option[j].qrcode.length !== 0 && item.option[j].qrcode[0].title !== '不限') {
              item.option[j].qrcode.unshift({
                title: '不限',
                id: ''
              })
            }
            if (item.option[j].qrcode.length === 0) {
              item.option[j].qrcode.unshift({
                title: '不限',
                id: ''
              })
            }
            item.qrcodeOptions = item.option[j].qrcode
          }
        }
        item.qrcode = ''
      }
      // 处理线下活动二维码选择问题
      if (item.selectedOptions[0] === 'event' && item.selectedOptions[2].split('@')[0] === 'scan_offline_qrcode') {
        for (let j in item.option) {
          if (item.value === item.option[j].id) {
            item.optionOther = item.option[j].offline
          }
        }
        item.offline_qrcode = ''
      }
      // 处理事件选择发送微信模板
      if (item.selectedOptions[0] === 'event' && item.selectedOptions[2].split('@')[0] === 'send_tpl_message') {
        for (let i in item.option) {
          if (item.value === item.option[i].id) {
            for (let one of item.option[i].template) {
              one.title = one.message_title
            }
            item.templateOption = JSON.parse(JSON.stringify(item.option[i].template))
            if (item.templateOption.length > 0 && item.templateOption[0].title !== '不限') {
              item.templateOption.unshift({
                title: '不限',
                message_title: '不限',
                id: ''
              })
            }
            if (item.templateOption.length === 0) {
              item.templateOption.unshift({
                title: '不限',
                message_title: '不限',
                id: ''
              })
            }
          }
        }
        item.template_id = ''
      }
      // 处理事件微信客服回复  选择回复微信模板
      if (item.selectedOptions[0] === 'event' && item.selectedOptions[2].split('@')[0] === 'public_to_reply') {
        item.public_reply_type_all.reply_content = null
        for (let i in item.option) {
          if (item.value === item.option[i].id) {
            // 模板消息
            let dataOne = JSON.parse(JSON.stringify(item.option[i].template))
            for (let one of dataOne) {
              one.name = one.message_title
              one.label = one.message_title
            }
            item.templatesTwo = dataOne
            item.templatesTwo.unshift({
              label: '不限',
              name: '不限'
            })
            // 大转盘
            let dataTwo = JSON.parse(JSON.stringify(item.option[i].lottery))
            for (let one of dataTwo) {
              one.label = one.name
            }
            item.activitiesTwo = dataTwo
            item.activitiesTwo.unshift({
              label: '不限',
              name: '不限'
            })
            // 微页面
            let dataThree = JSON.parse(JSON.stringify(item.option[i].scene))
            for (let one of dataThree) {
              one.label = one.admin_title
            }
            item.wepageTwo = dataThree
            item.wepageTwo.unshift({
              label: '不限',
              name: '不限'
            })
          }
        }
        item.template_id = ''
      }
      this.sendValues()
    },
    // 第一个属性群组事件等选择传值到父组件
    update(item) {
      // this.$nextTick(() => {
      // this.$refs.select.$el.querySelector('input').blur()
      // })
      // 解决change报错问题`
      if (typeof item !== 'undefined' && typeof item.value !== 'undefined') {
        // 判断属性对相对关系赋值
        item.relationship = ''
        let relationOptions = []
        if (item.selectedOptions[0] === 'attr') {
          /* -------------自定义属性的相对关系------------ */
          // 文本
          if (item.selectedOptions[1].split('@')[1] === 'input') {
            relationOptions = [
              {
                value: '=',
                label: '等于'
              }, {
                value: 'contain',
                label: '包含'
              }, {
                value: 'empty',
                label: '为空'
              },
              {
                value: 'not empty',
                label: '不为空'
              }
            ]
          }
          // 下拉
          if (item.selectedOptions[1].split('@')[1] === 'select') {
            relationOptions = [
              {
                value: '=',
                label: '等于'
              }, {
                value: '!=',
                label: '不等于'
              }, {
                value: 'empty',
                label: '为空'
              },
              {
                value: 'not empty',
                label: '不为空'
              }
            ]
          }
          // 日期
          if (item.selectedOptions[1].split('@')[1] === 'datePicker') {
            relationOptions = [
              {
                value: 'gt',
                label: '晚于'
              }, {
                value: '=',
                label: '等于'
              }, {
                value: 'lt',
                label: '早于'
              }, {
                value: 'gtele',
                label: '区间'
              }, {
                value: 'empty',
                label: '为空'
              },
              {
                value: 'not empty',
                label: '不为空'
              }
            ]
          }
          // 位置
          if (item.selectedOptions[1].split('@')[1] === 'addressPicker') {
            relationOptions = [
              {
                value: '=',
                label: '等于'
              }, {
                value: '!=',
                label: '不等于'
              }, {
                value: 'empty',
                label: '为空'
              },
              {
                value: 'not empty',
                label: '不为空'
              }
            ]
          }
          // 单选
          if (item.selectedOptions[1].split('@')[1] === 'radio') {
            relationOptions = [
              {
                value: '=',
                label: '等于'
              }, {
                value: 'empty',
                label: '为空'
              },
              {
                value: 'not empty',
                label: '不为空'
              }
            ]
          }
          // 复选
          if (item.selectedOptions[1].split('@')[1] === 'checkBox') {
            relationOptions = [
              {
                value: '=',
                label: '等于'
              }, {
                value: 'empty',
                label: '为空'
              },
              {
                value: 'not empty',
                label: '不为空'
              }
            ]
          }
          /* -------------系统属性的相对关系------------ */
          // 真实姓名
          if (item.selectedOptions[1].split('@')[0] === 'realname' && item.selectedOptions[1].split('@')[1] === 'input') {
            relationOptions = [
              {
                value: '=',
                label: '等于'
              }, {
                value: '!=',
                label: '不等于'
              }, {
                value: 'contain',
                label: '包含'
              }, {
                value: 'empty',
                label: '为空'
              },
              {
                value: 'not empty',
                label: '不为空'
              }
            ]
          }
          // 性别
          if (item.selectedOptions[1].split('@')[0] === 'sex' && item.selectedOptions[1].split('@')[1] === 'radio') {
            relationOptions = [
              {
                value: '=',
                label: '等于'
              }, {
                value: '!=',
                label: '不等于'
              }
            ]
          }
          // 当前等级
          if (item.selectedOptions[1].split('@')[0] === 'stage_id' && item.selectedOptions[1].split('@')[1] === 'radio') {
            relationOptions = [
              {
                value: '=',
                label: '等于'
              }, {
                value: '!=',
                label: '不等于'
              }
            ]
          }
          // 微信号
          if (item.selectedOptions[1].split('@')[0] === 'wechat' && item.selectedOptions[1].split('@')[1] === 'input') {
            relationOptions = [
              {
                value: '=',
                label: '等于'
              }, {
                value: '!=',
                label: '不等于'
              }, {
                value: 'contain',
                label: '包含'
              }, {
                value: 'empty',
                label: '为空'
              },
              {
                value: 'not empty',
                label: '不为空'
              }
            ]
          }
          // 省市区
          if (item.selectedOptions[1].split('@')[0] === 'systemPcd' && item.selectedOptions[1].split('@')[1] === 'addressPicker') {
            relationOptions = [
              {
                value: '=',
                label: '等于'
              }, {
                value: '!=',
                label: '不等于'
              }, {
                value: 'empty',
                label: '为空'
              },
              {
                value: 'not empty',
                label: '不为空'
              }
            ]
          }
          // 初始来源
          if (item.selectedOptions[1].split('@')[0] === 'source_id' && item.selectedOptions[1].split('@')[1] === 'radio') {
            relationOptions = [
              {
                value: '=',
                label: '等于'
              }, {
                value: '!=',
                label: '不等于'
              }, {
                value: 'empty',
                label: '为空'
              },
              {
                value: 'not empty',
                label: '不为空'
              }
            ]
          }
          // 手机号
          if (item.selectedOptions[1].split('@')[0] === 'mobile' && item.selectedOptions[1].split('@')[1] === 'input') {
            relationOptions = [
              {
                value: '=',
                label: '等于'
              }, {
                value: 'contain',
                label: '包含'
              }, {
                value: 'empty',
                label: '为空'
              },
              {
                value: 'not empty',
                label: '不为空'
              }
            ]
          }
          // 手机号验证
          if (item.selectedOptions[1].split('@')[0] === 'mobile_verified' && item.selectedOptions[1].split('@')[1] === 'radio') {
            relationOptions = [
              {
                value: '=',
                label: '等于'
              }
            ]
          }
          // 座机号
          if (item.selectedOptions[1].split('@')[0] === 'phone' && item.selectedOptions[1].split('@')[1] === 'input') {
            relationOptions = [
              {
                value: '=',
                label: '等于'
              }, {
                value: 'contain',
                label: '包含'
              }, {
                value: 'empty',
                label: '为空'
              },
              {
                value: 'not empty',
                label: '不为空'
              }
            ]
          }
          // 邮箱
          if (item.selectedOptions[1].split('@')[0] === 'email' && item.selectedOptions[1].split('@')[1] === 'input') {
            relationOptions = [
              {
                value: '=',
                label: '等于'
              }, {
                value: 'contain',
                label: '包含'
              }, {
                value: 'empty',
                label: '为空'
              },
              {
                value: 'not empty',
                label: '不为空'
              }
            ]
          }
          // 邮箱验证
          if (item.selectedOptions[1].split('@')[0] === 'email_verified' && item.selectedOptions[1].split('@')[1] === 'radio') {
            relationOptions = [
              {
                value: '=',
                label: '等于'
              }
            ]
          }
          // 生日
          if (item.selectedOptions[1].split('@')[0] === 'birthday' && item.selectedOptions[1].split('@')[1] === 'datePicker') {
            relationOptions = [
              {
                value: 'gt',
                label: '晚于'
              }, {
                value: '=',
                label: '等于'
              }, {
                value: 'lt',
                label: '早于'
              }, {
                value: 'gtele',
                label: '区间'
              }, {
                value: 'empty',
                label: '为空'
              },
              {
                value: 'not empty',
                label: '不为空'
              }
            ]
          }
          // 家庭住址
          if (item.selectedOptions[1].split('@')[0] === 'home_address' && item.selectedOptions[1].split('@')[1] === 'input') {
            relationOptions = [
              {
                value: 'contain',
                label: '包含'
              }, {
                value: 'empty',
                label: '为空'
              },
              {
                value: 'not empty',
                label: '不为空'
              }
            ]
          }
          // 公司名称
          if (item.selectedOptions[1].split('@')[0] === 'company' && item.selectedOptions[1].split('@')[1] === 'input') {
            relationOptions = [
              {
                value: 'contain',
                label: '包含'
              }, {
                value: 'empty',
                label: '为空'
              },
              {
                value: 'not empty',
                label: '不为空'
              }
            ]
          }
          // 公司地址
          if (item.selectedOptions[1].split('@')[0] === 'company_address' && item.selectedOptions[1].split('@')[1] === 'input') {
            relationOptions = [
              {
                value: 'contain',
                label: '包含'
              }, {
                value: 'empty',
                label: '为空'
              },
              {
                value: 'not empty',
                label: '不为空'
              }
            ]
          }
          // 备注
          if (item.selectedOptions[1].split('@')[0] === 'remark' && item.selectedOptions[1].split('@')[1] === 'input') {
            relationOptions = [
              {
                value: 'contain',
                label: '包含'
              }, {
                value: 'empty',
                label: '为空'
              },
              {
                value: 'not empty',
                label: '不为空'
              }
            ]
          }
          // 行业
          if (item.selectedOptions[1].split('@')[0] === 'industry' && item.selectedOptions[1].split('@')[1] === 'input') {
            relationOptions = [
              {
                value: 'contain',
                label: '包含'
              }, {
                value: 'empty',
                label: '为空'
              },
              {
                value: 'not empty',
                label: '不为空'
              }
            ]
          }
          // 职位
          if (item.selectedOptions[1].split('@')[0] === 'position' && item.selectedOptions[1].split('@')[1] === 'input') {
            relationOptions = [
              {
                value: 'contain',
                label: '包含'
              }, {
                value: 'empty',
                label: '为空'
              },
              {
                value: 'not empty',
                label: '不为空'
              }
            ]
          }
          // 是否会员
          if (item.selectedOptions[1].split('@')[0] === 'is_vip' && item.selectedOptions[1].split('@')[1] === 'radio') {
            relationOptions = [
              {
                value: '=',
                label: '等于'
              }
            ]
          }
          // 身份证号
          if (item.selectedOptions[1].split('@')[0] === 'id_number' && item.selectedOptions[1].split('@')[1] === 'input') {
            relationOptions = [
              {
                value: '=',
                label: '等于'
              }, {
                value: 'contain',
                label: '包含'
              }, {
                value: 'empty',
                label: '为空'
              },
              {
                value: 'not empty',
                label: '不为空'
              }
            ]
          }
          // 昵称
          if (item.selectedOptions[1].split('@')[0] === 'nickname' && item.selectedOptions[1].split('@')[1] === 'input') {
            relationOptions = [
              {
                value: '=',
                label: '等于'
              }, {
                value: 'contain',
                label: '包含'
              }, {
                value: 'empty',
                label: '为空'
              },
              {
                value: 'not empty',
                label: '不为空'
              }
            ]
          }
          // 创建时间
          if (item.selectedOptions[1].split('@')[0] === 'create_time' && item.selectedOptions[1].split('@')[1] === 'datePicker') {
            relationOptions = [
              {
                value: 'gt',
                label: '晚于'
              }, {
                value: '=',
                label: '等于'
              }, {
                value: 'lt',
                label: '早于'
              }, {
                value: 'gtele',
                label: '区间'
              }, {
                value: 'empty',
                label: '为空'
              },
              {
                value: 'not empty',
                label: '不为空'
              }
            ]
          }
          // 最后修改时间
          if (item.selectedOptions[1].split('@')[0] === 'update_time' && item.selectedOptions[1].split('@')[1] === 'datePicker') {
            relationOptions = [
              {
                value: 'gt',
                label: '晚于'
              }, {
                value: '=',
                label: '等于'
              }, {
                value: 'lt',
                label: '早于'
              }, {
                value: 'gtele',
                label: '区间'
              }, {
                value: 'empty',
                label: '为空'
              },
              {
                value: 'not empty',
                label: '不为空'
              }
            ]
          }
          // QQ
          if (item.selectedOptions[1].split('@')[0] === 'qq' && item.selectedOptions[1].split('@')[1] === 'input') {
            relationOptions = [
              {
                value: '=',
                label: '等于'
              }, {
                value: 'contain',
                label: '包含'
              }, {
                value: 'empty',
                label: '为空'
              },
              {
                value: 'not empty',
                label: '不为空'
              }
            ]
          }
          // 是否本公司员工
          if (item.selectedOptions[1].split('@')[0] === 'self_company' && item.selectedOptions[1].split('@')[1] === 'radio') {
            relationOptions = [
              {
                value: '=',
                label: '等于'
              }
            ]
          }
        }
        // 客户关键指标
        if (item.selectedOptions[0] === 'customer_kpi' && item.selectedOptions[1].split('@')[1] === 'input') {
          relationOptions = [
            {
              value: 'equal',
              label: '等于'
            }, {
              value: 'not_equal',
              label: '不等于'
            }, {
              value: 'gt',
              label: '大于'
            },
            {
              value: 'lt',
              label: '小于'
            },
            {
              value: 'gtele',
              label: '区间'
            }
          ]
        }
        // 客户身份
        if (item.selectedOptions[0] === 'customer_identity' && item.selectedOptions[1].split('@')[1] === 'input') {
          relationOptions = [
            {
              value: 'equal',
              label: '等于'
            }, {
              value: 'not_equal',
              label: '不等于'
            }, {
              value: 'empty',
              label: '为空'
            },
            {
              value: 'not empty',
              label: '不为空'
            }
          ]
        }
        item.relationOptions = relationOptions
        if (item.selectedOptions[0] === 'event') {
          item.value = ''
        } else if (item.selectedOptions[0] === 'follow_public') {
          item.value = null
        } else {
          item.value = null
        }
        item.qrcode = null
        item.offline_qrcode = null
        item.template_id = null
        item.optionOther = null
        item.qrcodeOptions = null
        item.templateOption = null
        item.public_reply_type_all.reply_type = '不限'
        item.public_reply_type_all.reply_content = null
        // 判断是不是事件
        if (item.selectedOptions[0] === 'event') {
          let strs = item.selectedOptions[2].split('@')
          for (let two of this.options[2].children) {
            for (let j in two.children) {
              if (strs[0] === two.children[j].identity) {
                item.option = two.children[j].option
                item.limit_attr = two.children[j].limit_attr
                item.attr_label = two.children[j].label
                item.optionOther = null
                item.qrcodeOptions = null
                item.templateOption = null
              }
            }
          }
          // 判断事件类型展示限制属性
          if (item.selectedOptions[1] === 'wechat' || item.selectedOptions[1] === 'wepage' || item.selectedOptions[1] === 'sms' || item.selectedOptions[1] === 'interactive_activities') {
            for (let ling of item.eventAttrOptions) {
              ling.attributeContent = ''
              ling.attributeRelation = ''
              ling.attributeValue = ''
              ling.attrValTimeStart = ''
              ling.attrValTimeEnd = ''
            }
            item.eventAttributeList = [
              {
                value: 'source',
                label: '来源'
              },
              {
                value: 'source_content',
                label: '来源内容'
              },
              {
                value: 'serial_number',
                label: '活动营销编码'
              }
            ]
          }
          if (item.selectedOptions[1] === 'user_defined_event') {
            for (let ling of item.eventAttrOptions) {
              ling.attributeContent = ''
              ling.attributeRelation = ''
              ling.attributeValue = ''
              ling.attrValTimeStart = ''
              ling.attrValTimeEnd = ''
              for (let er of item.limit_attr) {
                er.label = er.attr_name
                er.value = er.attr_identity
              }
              item.eventAttributeList = item.limit_attr
            }
          }
          if (item.selectedOptions[1] === 'order') {
            for (let yi of item.eventAttrOptions) {
              yi.attributeContent = []
              yi.attributeRelation = ''
              yi.attributeValue = ''
              yi.attrValTimeStart = ''
              yi.attrValTimeEnd = ''
              item.eventAttributeList = [
                {
                  value: 'goods_info',
                  label: '商品信息',
                  children: [
                    {
                      value: 'preferential_type',
                      label: '优惠类型'
                    },
                    {
                      value: 'coupon',
                      label: '优惠券'
                    },
                    {
                      value: 'goods_name',
                      label: '商品名称'
                    },
                    {
                      value: 'skuid',
                      label: 'skuid'
                    },
                    {
                      value: 'brand',
                      label: '品牌名称'
                    },
                    {
                      value: 'category',
                      label: '品类'
                    }
                  ]
                },
                {
                  value: 'order_info',
                  label: '订单信息',
                  children: [
                    {
                      value: 'distribution_channel',
                      label: '销售渠道'
                    },
                    {
                      value: 'shop_name',
                      label: '店铺名称'
                    },
                    {
                      value: 'order_no',
                      label: '订单号'
                    },
                    {
                      value: 'order_type',
                      label: '订单类型'
                    },
                    {
                      value: 'order_time',
                      label: '下单时间'
                    },
                    {
                      value: 'order_discount',
                      label: '订单折扣'
                    },
                    {
                      value: 'preferential_type',
                      label: '优惠类型'
                    },
                    {
                      value: 'coupon',
                      label: '优惠券'
                    },
                    {
                      value: 'pay_way',
                      label: '支付方式'
                    },
                    {
                      value: 'send_way',
                      label: '运送方式'
                    },
                    {
                      value: 'serial_number',
                      label: '营销活动编码'
                    }
                  ]
                },
                {
                  value: 'receive_goods_info',
                  label: '收货信息',
                  children: [
                    {
                      value: 'receiver_name',
                      label: '收货人姓名'
                    },
                    {
                      value: 'receiver_province',
                      label: '收货人省份'
                    },
                    {
                      value: 'receiver_city',
                      label: '收货人城市'
                    },
                    {
                      value: 'receiver_district',
                      label: '收货人区县'
                    },
                    {
                      value: 'receiver_street',
                      label: '收货人街道'
                    },
                    {
                      value: 'receiver_address',
                      label: '收货人详细地址'
                    }
                  ]
                },
                {
                  value: 'statistics_info',
                  label: '统计信息',
                  children: [
                    {
                      value: 'goods_types',
                      label: '商品种类数'
                    },
                    {
                      value: 'goods_num',
                      label: '商品件数'
                    },
                    {
                      value: 'unit_price',
                      label: '件单价'
                    }
                  ]
                }
              ]
            }
          }
        } else {
          let str = item.selectedOptions[1].split('@')
          for (let one of this.options) {
            for (let i in one.children) {
              if (str[0] === one.children[i].identity) {
                item.option = one.children[i].option
                item.attr_label = one.children[i].label
              }
            }
          }
        }
        // 处理公众号二维码选择问题
        if (item.selectedOptions[0] === 'event' && item.selectedOptions[2].split('@')[0] === 'scan_qrcode') {
          for (let j in item.option) {
            if (item.value === item.option[j].id) {
              item.qrcodeOptions = item.option[j].qrcode
            }
          }
        }
        // 处理公众号模板消息选择问题
        if (item.selectedOptions[0] === 'event' && item.selectedOptions[2].split('@')[0] === 'send_tpl_message') {
          for (let j in item.option) {
            if (item.value === item.option[j].id) {
              item.templateOption = item.option[j].template
            }
          }
        }
      }
      // 传值到父组件
      let allTerms = {}
      allTerms.allRelationship = this.outOperator
      for (let item of this.termsGroup) {
        for (let one of item.terms) {
          let firAttr = one.selectedOptions[0]
          one.attr = firAttr
        }
      }
      allTerms.termsGroup = this.termsGroup
      this.$emit('change', allTerms)
    },
    updateQrcodes(item) {
      this.sendValues()
    },
    updateQrcode(item) {
      this.sendValues()
    },
    // 添加一组查询条件
    addNewTermGroup() {
      this.termsGroup.push({
        inOperator: 'and',
        terms: [
          {
            attr: 'attr',
            attr_label: '真实姓名',
            relationship: '',
            relationOptions: [
              {
                value: '=',
                label: '等于'
              }, {
                value: '!=',
                label: '不等于'
              }, {
                value: 'contain',
                label: '包含'
              }, {
                value: 'empty',
                label: '为空'
              },
              {
                value: 'not empty',
                label: '不为空'
              }
            ],
            value: null,
            original_id: null,
            eventAttributeList: [],
            activitiesTwo: [],
            templatesTwo: [],
            wepageTwo: [],
            eventAttrOptions: [
              {
                attributeContent: '',
                relationOptions: [],
                sources: [],
                eventAttrValueOptions: [],
                attributeRelation: '',
                attr_type: '',
                attrValTimeStart: '',
                attrValTimeEnd: '',
                attributeValueStart: '',
                attributeValueEnd: '',
                attributeValue: ''
              }
            ],
            optionOther: null,
            qrcodeOptions: null,
            templateOption: null,
            qrcode: null,
            offline_qrcode: null,
            template_id: null,
            leave_word: null,
            public_reply_type_all: {
              reply_type: '不限',
              reply_content: ''
            },
            eventLimitTime: false,
            eventLimitTimes: false,
            eventLimitAttr: false,
            eventTimeRelation: '',
            eventDateStart: '',
            eventDateEnd: '',
            happenedTimes: '',
            start_time: '',
            end_time: '',
            selectedOptions: ['attr', 'realname@input']
          }
        ]
      })
    },
    // 删除当前这条查询条件
    removeTermItem(index, i) {
      this.termsGroup[i].terms.splice(index, 1)
      if (this.termsGroup[i].terms.length === 0) {
        this.termsGroup.splice(i, 1)
      }
    },
    // 添加一条查询条件
    addNewTerm(i) {
      this.termsGroup[i].terms.push({
        attr: 'attr',
        attr_label: '真实姓名',
        relationship: '',
        relationOptions: [
          {
            value: '=',
            label: '等于'
          }, {
            value: '!=',
            label: '不等于'
          }, {
            value: 'contain',
            label: '包含'
          }, {
            value: 'empty',
            label: '为空'
          },
          {
            value: 'not empty',
            label: '不为空'
          }
        ],
        value: null,
        original_id: null,
        eventAttributeList: [],
        activitiesTwo: [],
        templatesTwo: [],
        wepageTwo: [],
        eventAttrOptions: [
          {
            attributeContent: '',
            relationOptions: [],
            sources: [],
            eventAttrValueOptions: [],
            attributeRelation: '',
            attr_type: '',
            attrValTimeStart: '',
            attrValTimeEnd: '',
            attributeValueStart: '',
            attributeValueEnd: '',
            attributeValue: ''
          }
        ],
        optionOther: null,
        qrcodeOptions: null,
        templateOption: null,
        qrcode: null,
        offline_qrcode: null,
        template_id: null,
        leave_word: null,
        public_reply_type_all: {
          reply_type: '不限',
          reply_content: ''
        },
        eventLimitTime: false,
        eventLimitTimes: false,
        eventLimitAttr: false,
        eventTimeRelation: '',
        eventDateStart: '',
        eventDateEnd: '',
        happenedTimes: '',
        start_time: '',
        end_time: '',
        selectedOptions: ['attr', 'realname@input']
      })
    },
    // 处理地址选择
    handleAddressChange (value) {
    },
    // 条件选择
    handleChange(value) {
    },
    // 加载
    load() {
      // 获取属性列表
      let getAttr = getCustomerAttributeList()
      // 获取群组列表
      let getGroup = getGroupList(this.page, this.search, 0)
      // 获取事件列表
      let loadEvent = getCustomerEventList(1, '')
      // 获取公众号列表
      let loadWechatPublicList = getWechatPublicListForNode(1, '')
      // 获取微页面列表
      let loadWepageList = WePagesList(1, { publish_status: '' })
      // 获取短信列表
      let loadSmsList = getMessageListForNode(1, '')
      // 获取大转盘列表
      let loadBigWheelList = getBigWheelList()
      // 发送promiss请求并处理
      Promise.all([getAttr, getGroup, loadWechatPublicList, loadWepageList, loadSmsList, loadBigWheelList, loadEvent]).then(res => {
        // 处理属性
        if (res[0].data.code === 0) {
          let data = res[0].data.data
          let remainData = []
          // 循环删除省市区国家以及checkbox的元素  并且radio的改为select
          for (let i in data) {
            if (this.$route.path === '/home/member-list') {
              if (data[i].identity === 'is_vip') {
                continue
              }
            }
            if (data[i].identity === 'district' || data[i].identity === 'city' || data[i].identity === 'province' || data[i].identity === 'country') {
              continue
            }
            if (data[i].identity === 'source_id') {
              getSourceData().then((res) => {
                data[i].option = []
                for (let item of res.data.data.list) {
                  data[i].option.push({
                    name: item.name,
                    id: item.id
                  })
                }
              })
            }
            if (data[i].identity === 'stage_id') {
              getCustomerStage().then((res) => {
                data[i].option = [
                  {
                    name: '未知等级',
                    id: 0
                  }
                ]
                for (let item of res.data.data) {
                  data[i].option.push({
                    name: item.name,
                    id: item.id
                  })
                }
              })
            }
            remainData.push(data[i])
          }
          // 拼接处理获得的属性列表到本地数据
          for (let i in remainData) {
            remainData[i].value = remainData[i].identity + '@' + remainData[i].type
            remainData[i].label = remainData[i].name
          }
          remainData.push({
            label: '省市区',
            value: 'systemPcd@addressPicker'
          })
          this.options[0].children = remainData
        }
        // 处理群组
        if (res[1].data.code === 0) {
          for (let item of res[1].data.data.list) {
            item.label = item.name
            item.value = item.id
          }
          let option = []
          option = res[1].data.data.list
          this.options[1].children.push(
            {
              label: '在此群组中',
              value: 'inGroup@select',
              option: option,
              identity: 'inGroup'
            }
          )
          this.options[1].children.push(
            {
              label: '不在此群组中',
              value: 'notInGroup@select',
              option: option,
              identity: 'notInGroup'
            }
          )
        }
        // 处理公众号列表
        if (res[2].data.code === 0) {
          for (let item of res[2].data.data.list) {
            item.label = item.nick_name
            item.value = item.id
          }
          let arr = JSON.parse(JSON.stringify(res[2].data.data.list))
          res[2].data.data.list.unshift({
            label: '不限',
            value: '',
            qrcode: []
          })
          this.wechatPublic = res[2].data.data.list
          // 将公众号给到是否关注公众号的select
          this.options[3].children.push(
            {
              label: '当前关注',
              value: 'follow_now@select',
              option: arr,
              identity: 'follow_now'
            }
          )
          this.options[3].children.push(
            {
              label: '从未关注',
              value: 'follow_never@select',
              option: arr,
              identity: 'follow_never'
            }
          )
          this.options[3].children.push(
            {
              label: '取消关注',
              value: 'follow_cancel@select',
              option: arr,
              identity: 'follow_cancel'
            }
          )
        }
        // 处理微页面
        if (res[3].data.code === 0) {
          // one是给微页面事件用的 two是微信回复类型里面的微页面
          let dataOne = res[3].data.data.list
          for (let item of dataOne) {
            item.label = item.admin_title
            item.value = item.id
          }
          dataOne.unshift({
            label: '不限',
            value: ''
          })
          this.wepage = dataOne
        }
        // 处理短信
        if (res[4].data.code === 0) {
          for (let item of res[4].data.data.list) {
            item.label = item.sms_name
            item.value = item.id
          }
          res[4].data.data.list.unshift({
            label: '不限',
            value: ''
          })
          this.sms = res[4].data.data.list
        }
        // 处理大转盘列表
        if (res[5].data.code === 0) {
          // one是给微页面事件用的 two是微信回复类型里面的微页面
          let dataOne = res[5].data.data.list
          for (let item of dataOne) {
            item.label = item.name
            item.value = item.id
          }
          dataOne.unshift({
            label: '不限',
            value: ''
          })
          this.activities = dataOne
        }
        // 处理客户事件
        if (res[6].data.code === 0) {
          // 拼接处理获得的事件列表到本地数据
          let data = res[6].data.data.list
          let remainData = [
            {
              value: 'wechat',
              label: '微信',
              children: []
            },
            {
              value: 'wepage',
              label: '微页面',
              children: []
            },
            {
              value: 'sms',
              label: '短信',
              children: []
            },
            {
              value: 'interactive_activities',
              label: '互动活动',
              children: []
            },
            {
              value: 'order',
              label: '订单',
              children: []
            },
            {
              value: 'user_defined_event',
              label: '自定义事件',
              children: []
            }
          ]
          for (let i in data) {
            if (data[i].pid === 22) {
              remainData[0].children.push({
                value: data[i].identity + '@' + 'select',
                label: data[i].name,
                identity: data[i].identity,
                option: this.wechatPublic
              })
            }
            if (data[i].pid === 23) {
              remainData[1].children.push({
                value: data[i].identity + '@' + 'select',
                label: data[i].name,
                identity: data[i].identity,
                option: this.wepage
              })
            }
            if (data[i].pid === 24) {
              remainData[2].children.push({
                value: data[i].identity + '@' + 'select',
                label: data[i].name,
                identity: data[i].identity,
                option: this.sms
              })
            }
            if (data[i].pid === 26) {
              remainData[4].children.push({
                value: data[i].identity + '@' + '',
                label: data[i].name,
                identity: data[i].identity,
                option: []
              })
            }
            if (data[i].pid === 28) {
              remainData[3].children.push({
                value: data[i].identity + '@' + 'select',
                label: data[i].name,
                identity: data[i].identity,
                option: this.activities
              })
            }
            if (data[i].pid === 29) {
              remainData[5].children.push({
                value: data[i].identity + '@' + '',
                label: data[i].name,
                identity: data[i].identity,
                option: [],
                limit_attr: data[i].attr
              })
            }
            if (data[i].identity === 'Integral_increase' || data[i].identity === 'integral_reduction') {
              continue
            }
          }
          // remainData.push(data[i])
          this.options[2].children = remainData
          console.log('this.options[2].children', this.options)
        }
      })
      if (this.allRelationship) {
        this.outOperator = this.allRelationship
      } else if (this.allRelationshipSearch) {
        this.outOperator = this.allRelationshipSearch
      }
    }
  },
  mounted() {
    this.load()
  },
  created() {
    this.update()
    console.log('10101', this.activities)
  }
}
</script>

<style scoped>
</style>
